const t = "styles-module__toasts___3bUuS", s = "styles-module__container___oAHFb", o = {
  toasts: t,
  container: s
};
export {
  s as container,
  o as default,
  t as toasts
};
